import "@patron/patron-css/patron/index.css";
import React from "react";
import PropTypes from "prop-types";

import "./RequestManualToken.scss";
import { useTranslation } from "react-i18next";

function RequestManualToken(props) {
  const { t } = useTranslation();

  function setModalClose() {
    props.setModalClose(false);
  }
  return (
    <div className="container">
      <div className="mdm-hr"></div>
      <h4 className="headline">{t("manualTokenGeneration")}</h4>
      <p>
        <span className="important">{t("important")}</span>
        {t("manualTokenGenerationDescription")}
      </p>

      <div className="field">
        <label>{t("mailTo")}</label>
        <div className="input-box">
          <span>{props.mailTo}</span>
          <button
            onClick={() => {
              navigator.clipboard.writeText(props.mailTo);
            }}
            className="copy-btn"
          >
            <i class="p-hclsw p-hclsw-copy icon-in-tad-button"> </i>
          </button>
        </div>
      </div>

      <div className="field">
        <label>{t("mailContent")}</label>
        <div className="input-box">
          <span>{props.mailContent}</span>
          <button
            onClick={() => {
              navigator.clipboard.writeText(props.mailContent);
            }}
            className="copy-btn"
          >
            <i class="p-hclsw p-hclsw-copy icon-in-tad-button"> </i>
          </button>
        </div>
      </div>

      <div className="field">
        <label>{t("mailSubject")}</label>
        <div className="input-box">
          <span>{props.mailSubject}</span>
          <button
            onClick={() => {
              navigator.clipboard.writeText(props.mailSubject);
            }}
            className="copy-btn"
          >
            <i class="p-hclsw p-hclsw-copy icon-in-tad-button"> </i>
          </button>
        </div>
      </div>

      <button className="reset-btn" onClick={setModalClose}>
        ↻ Reset
      </button>
      <div className="mdm-hr"></div>
    </div>
  );
}
RequestManualToken.propTypes = {
  setModalClose: PropTypes.func.isRequired,
  mailTo: PropTypes.string.isRequired,
  mailSubject: PropTypes.string.isRequired,
  mailContent: PropTypes.string.isRequired,
};

export default RequestManualToken;